<template>
    <div class="col-12 col-md-6" v-if="!hide">
        <div class="content owners">
            <div class="h5 title">{{$t('views.audience.sections.owners.title')}}</div>
            <LoadingSection v-if="loading" :showMessage="false" />
            <ul class="stats" v-else-if="!loading && owners?.length > 0">
                <li class="stat" v-for="user in owners" :key="user.uid" @click.stop="openProspects(user)">
                    <div class="image">
                        <GravatarImage 
                            :email="user.email ? user.email : null"
                            :name="user.name ? user.name : user.email ? user.email : null"
                        />
                    </div>
                    <div class="h5 name">{{user.name ? user.name  : user.email}}<span v-if="user.name">{{user.email}}</span></div>
                    <div class="p value">{{formatNumber(audience.stats.owner[user.uid])}}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'pinia';
    import { useAudienceStore } from '@/stores/audience';
    import { useUsersStore } from '@/stores/users';
    import { formatNumber } from '@/utils/formatting';
    import GravatarImage from '@/components/misc/GravatarImage';
    import LoadingSection from '@/components/sections/LoadingSection';

    export default {
        name: "AudienceOwners",
        emits: ['update-visibility'],
        components: {
            LoadingSection,
            GravatarImage
        },
        data() {
            return {
                loaded: false
            }
        },
        computed: {
            ...mapState(useAudienceStore, ['audience']),
            ...mapState(useUsersStore, ['loading', 'users']),
            owners() {
                if (!this.audience?.stats?.owner) return [];
                return this.users.filter(user => this.audience.stats.owner[user.uid]);
            },
            hide() {
                return this.loaded && this.owners?.length < 1;
            }
        },
        methods: {
            formatNumber,
            ...mapActions(useUsersStore, ['getUsers']),
            openProspects(owner) {
                this.$router.push({
                    name: 'audienceProspects',
                    query: { 
                        prospectOptions: JSON.stringify({
                            reset: true,
                            options: {
                                owner: owner.uid
                            }
                        })
                    }
                });
            }
        },
        watch: {
            hide() {
                this.$emit('update-visibility');
            }
        },
        async mounted() {
            await this.getUsers();
            this.loaded = true;
        },
    }
</script>